import React from "react"

import styles from "../../../../css/Checkbox.module.css"

const Checkbox = props => {
  return (
    <div>
      <div className={styles.input}>
        <input
          type="checkbox"
          name={props.name}
          checked={props.inputState[props.name].value}
          onChange={props.onInputChange}
        />
      </div>
      <div className={styles.label}>
        {props.label}
      </div>
    </div>
  )
}

export default Checkbox